export const messages = {
  en: {
    openApiAuth: {
      title: 'Open API Auth Management',
      appId: 'App ID',
      appName: 'App Name',
      merchantName: 'Merchant Name',
      merchantAddress: 'Merchant Address',
      appKey: 'App Key',
      status: 'Status',
      createTime: 'Create Time',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      keyInfo: 'Key Info',
      detail: 'Detail',
      queryCondition: 'Query Conditions',
      inputAppId: 'Please enter app ID',
      inputAppName: 'Please enter app name',
      search: 'Search',
      add: 'Add',
      statusAll: 'All',
      statusEnable: 'Enable',
      statusDisable: 'Disable',
      appSecret: 'App Secret',
      publicKey: 'Public Key',
      privateKey: 'Private Key',
      remark: 'Remark',
      noData: 'No Data',
      enabled: 'Enable',
      disabled: 'Disable',
      fetchError: 'Failed to fetch data',
      selectMerchant: 'Select Merchant'
    },
    addOpenApiApp: {
      addApp: 'Add App',
      appId: 'App ID',
      inputAppId: 'Required, please enter app ID',
      appName: 'App Name',
      inputAppName: 'Required, please enter app name',
      remark: 'Remark',
      inputRemark: 'Please enter remark',
      cancel: 'Cancel',
      confirm: 'Confirm',
      appIdRequired: 'App ID is required',
      appNameRequired: 'App Name is required',
      addSuccess: 'Add successful',
      appIdExist: 'App ID already exists',
      appNameExist: 'App Name already exists'
    },
    editOpenApiApp: {
      editApp: 'Edit App',
      appId: 'App ID',
      inputAppId: 'Required, please enter app ID',
      appName: 'App Name',
      inputAppName: 'Required, please enter app name',
      remark: 'Remark',
      inputRemark: 'Please enter remark',
      cancel: 'Cancel',
      confirm: 'Confirm',
      appIdRequired: 'App ID is required',
      appNameRequired: 'App Name is required',
      editSuccess: 'Edit successful',
      appIdExist: 'App ID already exists',
      appNameExist: 'App Name already exists'
    },
    deleteOpenApiApp: {
      confirmOperation: 'Please confirm your operation',
      confirmDelete: 'Confirm to delete?',
      cancel: 'Cancel',
      confirm: 'Confirm Delete',
      deleteSuccess: 'Delete successful'
    },
    keyInfoDialog: {
      keyInfo: 'Key Info',
      appKey: 'App Key',
      publicKey: 'Public Key',
      privateKey: 'Private Key',
      close: 'Close',
      copySuccess: 'Copy successful'
    },
    detailDialog: {
      detail: 'Detail',
      appId: 'App ID',
      appName: 'App Name',
      appKey: 'App Key',
      status: 'Status',
      createTime: 'Create Time',
      remark: 'Remark',
      close: 'Close',
      enable: 'Enable',
      disable: 'Disable'
    }
  },
  zh: {
    openApiAuth: {
      title: '开放API鉴权管理',
      appId: '应用ID',
      appName: '应用名称',
      merchantName: '商家名称',
      merchantAddress: '商家地址',
      appKey: '应用密钥',
      status: '状态',
      createTime: '创建时间',
      operation: '操作',
      edit: '修改',
      delete: '删除',
      keyInfo: '密钥信息',
      detail: '详情',
      queryCondition: '查询条件',
      inputAppId: '请输入应用ID',
      inputAppName: '请输入应用名称',
      search: '查询',
      add: '添加',
      statusAll: '全部',
      statusEnable: '启用',
      statusDisable: '禁用',
      appSecret: '应用密钥',
      publicKey: '公钥',
      privateKey: '私钥',
      remark: '备注',
      noData: '暂无数据',
      enabled: '启用',
      disabled: '禁用',
      fetchError: '获取数据失败',
      selectMerchant: '选择商家'
    },
    addOpenApiApp: {
      addApp: '添加应用',
      appId: '应用ID',
      inputAppId: '必填，请输入应用ID',
      appName: '应用名称',
      inputAppName: '必填，请输入应用名称',
      remark: '备注',
      inputRemark: '请输入备注',
      cancel: '取消',
      confirm: '确认',
      appIdRequired: '应用ID不能为空',
      appNameRequired: '应用名称不能为空',
      addSuccess: '添加成功',
      appIdExist: '应用ID已存在',
      appNameExist: '应用名称已存在'
    },
    editOpenApiApp: {
      editApp: '修改应用',
      appId: '应用ID',
      inputAppId: '必填，请输入应用ID',
      appName: '应用名称',
      inputAppName: '必填，请输入应用名称',
      remark: '备注',
      inputRemark: '请输入备注',
      cancel: '取消',
      confirm: '确认',
      appIdRequired: '应用ID不能为空',
      appNameRequired: '应用名称不能为空',
      editSuccess: '修改成功',
      appIdExist: '应用ID已存在',
      appNameExist: '应用名称已存在'
    },
    deleteOpenApiApp: {
      confirmOperation: '请确认您的操作',
      confirmDelete: '确认是否删除？',
      cancel: '点错了',
      confirm: '确认删除',
      deleteSuccess: '删除成功'
    },
    keyInfoDialog: {
      keyInfo: '密钥信息',
      appKey: '应用密钥',
      publicKey: '公钥',
      privateKey: '私钥',
      close: '关闭',
      copySuccess: '复制成功'
    },
    detailDialog: {
      detail: '详情',
      appId: '应用ID',
      appName: '应用名称',
      appKey: '应用密钥',
      status: '状态',
      createTime: '创建时间',
      remark: '备注',
      close: '关闭',
      enable: '启用',
      disable: '禁用'
    }
  }
}